import { createStore } from 'vuex'
import home from './modules/home'
import { RootState } from './types'
import basicLocation from './modules/basicLocation'
import clientConfigModule from './modules/clientConfig'
import type {
  AdConfig,
  BrandingConfig,
  ClientConfig,
  FeatureConfig,
  LanguageConfig,
  RefreshConfig,
  ThemeConfig,
  VideoConfig,
} from '@/config/types'

const store = createStore<RootState>({
  getters: {},
  mutations: {
    setLoading(state, payload: boolean) {
      state.loading = payload
    },
    setIsMapFailed(state, payload: boolean) {
      state.isMapFailed = payload
    },
    setDataError(state, payload: boolean) {
      state.dataError = payload
    },
    setHomeSelectedElement(state, el: string | undefined) {
      state.homeSelectedElement = el
    },
    setMenuOpened(state, payload: boolean) {
      state.isMenuOpened = payload
    },
    setFullscreenMenuOpened(state, payload: number | false) {
      state.isFullscreenMenuOpened = payload === false ? 0 : payload
    },
  },
  actions: {},
  modules: {
    home,
    basicLocation,
    clientConfig: clientConfigModule,
  },
})

export default store

const TRANSPARENT_FAVICON =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

export const clientConfig = {
  get config(): ClientConfig {
    return store.state.clientConfig.config
  },
  get theme(): ThemeConfig {
    return this.config.theme
  },
  get branding(): BrandingConfig {
    return this.config.branding
  },
  get video(): VideoConfig {
    return this.config.video
  },
  get ad(): AdConfig {
    return this.config.ad
  },
  get features(): FeatureConfig {
    return this.config.features
  },
  get language(): LanguageConfig {
    return this.config.language
  },
  get refresh(): RefreshConfig {
    return this.config.refresh
  },
  get clientId(): string {
    return this.config.clientId ?? 'accuweather'
  },
  get isAccuweather(): boolean {
    return this.clientId === 'accuweather'
  },
  get logoSrc(): string {
    if (this.branding.logoUrl) return this.branding.logoUrl
    if (this.isAccuweather) return require('@/assets/images/accuweather-logo.svg')
    return ''
  },
  get logoAlt(): string {
    return this.branding.logoAlt ?? 'AccuWeather'
  },
  get adImg(): string | undefined {
    if (!this.ad.enabled) return undefined
    if (this.ad.imageUrl) return this.ad.imageUrl
    if (this.isAccuweather) return require('@/assets/images/ads/ADQr.svg')
    return undefined
  },
  get adBackdropUrl(): string | null {
    return this.isAccuweather ? require('@/assets/images/ads/background-ad.png') : null
  },
  get faviconHref(): string {
    return this.isAccuweather ? '/favicon.ico' : TRANSPARENT_FAVICON
  },
  get showAccuweatherMark(): boolean {
    return this.isAccuweather
  },
  classModifier(prefix: string): string {
    return `${prefix}--${this.isAccuweather ? 'accuweather' : 'client'}`
  },
}
